
export default {
    name: 'taux-bilan-sante',
    components: {},
    props: [],
    data() {
        return {

        }
    },
    
    computed: {

    },

    mounted() {

    },

    methods: {

    }
}